import { render, staticRenderFns } from "./CreateNews.vue?vue&type=template&id=b287be84"
import script from "./CreateNews.vue?vue&type=script&lang=js"
export * from "./CreateNews.vue?vue&type=script&lang=js"
import style0 from "./CreateNews.vue?vue&type=style&index=0&id=b287be84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports